// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__T9zi1","description":"PatientConsentPreview_description__2TeTE"};